// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JqnE","rootNoMargin":"styles_rootNoMargin__3f6W5"};